module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add":"Added","remove":"Removed","priceLines":"Pricelines","chargeCode":"Code","currency":"Currency","amount":"Amount","text":"Text"},"no":{"add":"Laget","remove":"Slettet","priceLines":"Prislinjer","chargeCode":"Kode","currency":"Valuta","amount":"Beløp","text":"Tekst"}}')
  delete Component.options._Ctor
}
